import { InputBase } from '@mui/material';
import { styled } from '@mui/material/styles';
import fonts from '../../themes/fonts';
import colors from '../../themes/colors';

export const InputText = styled(InputBase)(({ theme }) => ({
  border: 'none',
  borderRadius: '8px',
  '& .MuiInputBase-input': {
    border: 'none',
    fontFamily: fonts.Medium,
    fontWeight: 'normal',
    fontSize: '18px',
    color: colors['greyish-brown'],
    padding: theme.spacing(0.625, 1),
    '&::placeholder': {
      fontFamily: fonts.Medium,
      fontWeight: 'normal',
      fontSize: '15px',
      color: colors.graySeventh,
      paddingLeft: theme.spacing(1),
    },
  },
}));

const styles = {
  label: {
    color: colors.blackMain,
    fontSize: '17px',
    fontFamily: fonts.Medium,
    margin: '0px',
  },
  customInput: {
    // padding: '1.5px 5px',
    width: '100%',
    fontSize: '13px',
    background: 'none',
    fontWeight: 600,
  },
  nativeDateInput: {
    display: 'block',
    width: '100%',
    border: 'none',
    borderRadius: '4px',
    outline: 'none',
    padding: '8px 10px',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    color: 'inherit',
  },
  prefix: {
    fontSize: '18px',
    paddingLeft: '5px',
  },
};

export default styles;
